import React, { Component } from "react";
import { Navigate, Link } from "react-router-dom";

import "./Shared.css";
import "./Trade.css";

import withRouter from "./functions/withRouter";
import { getFavoriteBook, getBook, decode } from "./functions/books";

import Book from "./Book";
import Loading from "./Loading";

class Trade extends Component {
  constructor(props) {
    super(props);

    this.state = {givingBook: getFavoriteBook(), receivingBook: null}
  }

  componentDidMount() {
    getBook(this.props.params.bookID).then((book) => {
      this.setState({receivingBook: book})
    });
  }

  renderTrade() {
    return (
      <div>
        <div className="Callout TradeSummary">
          <Link to="/"><img className="ClearBook" src="/foreword/images/x.png" alt="Start Over" /></Link>

          <div className="Sending">
            Your Trade
          </div>

          <div className="Row JustifyCenter">
            <div className="Column Center">
              <div className="TextPadding TextSmall">Sending</div>
              <Book book={this.state.givingBook} />
            </div>

            <div className="Column JustifyCenter">
              <img src="/foreword/images/exchange.png" alt="Exchange" className="ExchangeIcon ExchangeIconWhite" />
            </div>

            <div className="Column Center">
              <div className="TextPadding TextSmall">Receiving</div>
              {this.state.receivingBook ?
                <Book book={this.state.receivingBook} /> :
                <Loading />
              }
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderTradeOptions() {
    return (
      <div>
        <h2>How would you like to trade?</h2>
        <div className="TradeOptions">
          <div className="TradeOption">
            <h3>Mail us your original copy!</h3>
            <div>If you own a copy of <i>{this.state.givingBook.title}</i>, mail it to us and we will make it available for others to choose on the catalogue. Once we receive your copy, we will send you <i>{this.state.receivingBook.title}</i>.</div>
            <Link to={`/trade/start/${this.state.receivingBook.id}/mail`}><div className="Button Purple Margin">Mail Your Copy</div></Link>
          </div>

          <div className="TradeOption">
            <h3>We grab a copy for you!</h3>
            <div>If you don't own <i>{this.state.givingBook.title}</i> or prefer not to mail in your original, we will buy a copy on your behalf to make available for others. We’ll immediately send you <i>{this.state.receivingBook.title}</i> if you choose this option.</div>
            <Link to={`/trade/start/${this.state.receivingBook.id}/buy`}><div className="Button Purple Margin">Buy & Ship</div></Link>
          </div>
        </div>
      </div>
    );
  }

  render() {
    if (!this.state.givingBook) {
      return (<Navigate to="/" replace={true} />);

    } else if (!this.state.receivingBook) {
      return (<Loading />);

    } else {
      return (
        <div className="Content">
          <h1 className="HeaderText">Foreword</h1>

          <div className="TradeContainer">
            {this.renderTrade()}

            <div className="TradeRightColumn">
              {(this.state.receivingBook.comment) ? <div>
                <h2>This is someone’s favorite book!</h2>
                <div className="Quote">{this.state.receivingBook.comment}</div>
                <h3>More about <i>{this.state.receivingBook.title}</i>:</h3></div>
              : <h2>About <i>{this.state.receivingBook.title}</i></h2>}
              <div className="Quote">{decode(this.state.receivingBook.description)}</div>

              {this.renderTradeOptions()}
            </div>
          </div>
        </div>
      );
    }
  }
}

export default withRouter(Trade);
